import { Week } from "app/models/week"
import { Action, Types } from "./weeks.actions"

export type WeekState = {
  errors: {}
  loading: boolean
  data: Week | undefined
}

const initialState: WeekState = {
  data: undefined,
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): WeekState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
